import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useWindowSize } from "../../../../../Helpers";
import { useResolvedGameData } from "../../../resolveGameData";
import Button from "@components/Button";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import BrandLogo from "@components/BrandLogo";
import WrongAnswerPopup, {
  wrongAnswerPopupSpringSettings,
} from "@components/WrongAnswerPopup";
import DOMPurify from "dompurify";
import { useTransition } from "@react-spring/web";

export default function Quiz({
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
  sendAnswers,
}) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const gameQuestionsQuery = useResolvedGameData(answers);
  const XGA = width >= 1020;
  const [selected, setSelected] = useState(-1);
  const [wrongAnswerPopupSettings, setWrongAnswerPopupSettings] = useState({
    visible: false,
    forElement: null,
  });
  const isUltraInsider =
    location.pathname.includes("/ultra-insider") ||
    location.pathname.includes("/ultrainsider");

  const identsWithoutCorrectAnswers = [
    "poll_1",
    "quiz_14",
    "quiz_15",
    "quiz_27",
    "quiz_28",
  ];

  const CheckAnswers = () => {
    const currentQuestionIdent =
      gameQuestionsQuery.content[currentQuestion].ident;
    const selectedAnswerIdent =
      gameQuestionsQuery.content[currentQuestion].answers[selected].ident;

    setAnswers((prevAnswers) => {
      const isQuestionAlreadyAnswered = prevAnswers.find(
        (answer) => answer.question_ident === currentQuestionIdent,
      );

      if (
        !isQuestionAlreadyAnswered &&
        (gameQuestionsQuery.content[currentQuestion].correctAnswer === null ||
          selected ===
            gameQuestionsQuery.content[currentQuestion].correctAnswer)
      ) {
        return [
          ...prevAnswers,
          {
            question_ident: currentQuestionIdent,
            answer_ident: selectedAnswerIdent,
          },
        ];
      }
      return prevAnswers;
    });
  };

  useEffect(() => {
    if (selected !== -1) {
      CheckAnswers();
    }
  }, [selected]);

  const handleAnswerClick = (index) => {
    const { visible: wrongAnswerPopupVisible, forElement } =
      wrongAnswerPopupSettings;

    if (wrongAnswerPopupVisible && forElement !== index) {
      setWrongAnswerPopupSettings({ forElement: index, visible: false });
    }

    setSelected(index);
  };

  const handleNextButtonClick = () => {
    const skipCheckAnswers =
      gameQuestionsQuery.content[currentQuestion].correctAnswer === null ||
      identsWithoutCorrectAnswers.includes(ident);

    // if (skipCheckAnswers && selected === -1) {
    //   return;
    // }

    if (
      !skipCheckAnswers &&
      selected !== gameQuestionsQuery.content[currentQuestion].correctAnswer
    ) {
      setWrongAnswerPopupSettings({ forElement: selected, visible: true });
      return;
    }

    setCurrentQuestion(currentQuestion + 1);
    setSelected(-1);

    if (gameQuestionsQuery.answersNumber === answers.length) {
      console.log("Sending answers auto quiz");
      sendAnswers();
    }
  };

  console.log(answers);
  console.log(selected);

  const wrongAnswerPopupTransition = useTransition(
    wrongAnswerPopupSettings.visible,
    wrongAnswerPopupSpringSettings,
  );

  return (
    <section
      className={`game-page quiz-mechanics ${ident} ${
        isUltraInsider ? "ultra-insider" : ""
      }`}
    >
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
            <LinearGradientProgressBar
              value={currentQuestion / gameQuestionsQuery.content.length}
            />
            <div className="game-question">
              <h2
                className="question"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion].question),
                }}
              />
            </div>
            <div
              className={`answer-content ${ident} ${
                gameQuestionsQuery.content[currentQuestion].imgAnswers
                  ? "imgAnswer"
                  : ""
              }`}
            >
              <div className="answers-wrapper">
                {gameQuestionsQuery.content[currentQuestion].answers.map(
                  ({ answer }, index) => (
                    <button
                      className={`answer ${
                        index === selected ? "selected" : ""
                      }`}
                      key={index}
                      onClick={() => handleAnswerClick(index)}
                    >
                      <div className="inner">
                        <span className="oval" />
                        {answer?.textImage ? (
                          <>
                            <img src={answer.textImage.img} alt="" />
                            <p>{answer.textImage.text}</p>
                          </>
                        ) : gameQuestionsQuery.content[currentQuestion]
                            .imgAnswers ? (
                          <img
                            alt="answerIMG"
                            src={answer}
                            className="answerImg"
                          ></img>
                        ) : (
                          <p>{answer}</p>
                        )}
                      </div>
                    </button>
                  ),
                )}
              </div>
            </div>
            <a
              href={gameQuestionsQuery.content[currentQuestion]?.questDisLink}
              target="_blank"
              rel="noopener noreferrer"
              className="answer-dis"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion]?.questDis),
              }}
            ></a>
          </div>
          <div className="side-img">
            <BrandLogo brands={gameQuestionsQuery?.brands} />
            {gameQuestionsQuery.content[currentQuestion].desktopImgHid ? (
              selected ===
              gameQuestionsQuery.content[currentQuestion].correctAnswer ? (
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImg" : "desktopImg"
                    ]
                  }
                  alt=""
                />
              ) : (
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImgHid" : "desktopImgHid"
                    ]
                  }
                  alt=""
                />
              )
            ) : (
              <div className="img-wrapper">
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImg" : "desktopImg"
                    ]
                  }
                  alt=""
                />
                {gameQuestionsQuery.content[currentQuestion]?.sideImageCopy && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html:
                        DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion]
                          ?.sideImageCopy),
                    }}
                  />
                )}
              </div>
            )}
            {XGA && (
              // replace "StickyContent" with something called respectively
              <StickyContent>
                {wrongAnswerPopupTransition(
                  (style, item) =>
                    item && (
                      <WrongAnswerPopup
                        visible={wrongAnswerPopupSettings}
                        onClose={() =>
                          setWrongAnswerPopupSettings((prev) => ({
                            ...prev,
                            visible: false,
                          }))
                        }
                        style={style}
                      />
                    ),
                )}
                <div className="desktop-buttons">
                  <Button
                    action={handleNextButtonClick}
                    disabled={selected === -1}
                  >
                    {gameQuestionsQuery.content[currentQuestion]
                      .nextButtonCopy ?? "Nächste"}
                  </Button>
                </div>
              </StickyContent>
            )}
          </div>
        </div>
      </div>
      {!XGA && (
        // replace with "StickyContent"
        <StickyButton
          action={handleNextButtonClick}
          disabled={selected === -1}
          additionalElement={wrongAnswerPopupTransition(
            (style, item) =>
              item && (
                <WrongAnswerPopup
                  visible={wrongAnswerPopupSettings}
                  onClose={() =>
                    setWrongAnswerPopupSettings((prev) => ({
                      ...prev,
                      visible: false,
                    }))
                  }
                  style={style}
                />
              ),
          )}
        >
          {gameQuestionsQuery.content[currentQuestion].nextButtonCopy ??
            "Nächste"}
        </StickyButton>
      )}
    </section>
  );
}
